import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import { Modal } from 'antd';
import { updateBondDetailsService } from '../../../services/FileDataService'

const BondEditModal = (props) => {
  const [formValues, setFormValues] = useState({
    signal_bond_details_id: '',
    bond_type: '',
    bond_name: '',
    file_no: '',
    submitted_to: '',
    bond_no: '',
    bg_no: '',
    accepted_date: '',
    bond_value: '',
    bg_value: '',
    expiry_date: '',
    obligation_base: '',
    date: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    setFormValues({});
    props.handleClose();
  };

  const handleOk = async () => {
    const token = localStorage.getItem('token');
    try {
      const sanitizedValues = { ...formValues };

      // Clean dates: empty string or null/undefined to null
      const dateFields = ['accepted_date', 'expiry_date', 'date'];
      dateFields.forEach(field => {
        if (!sanitizedValues[field] || sanitizedValues[field] === '') {
          sanitizedValues[field] = null;
        }
      });

      // Clean other optional fields
      const optionalFields = ['submitted_to', 'bond_value', 'bg_value', 'bg_no', 'obligation_base', 'file_no'];
      optionalFields.forEach(field => {
        if (sanitizedValues[field] === undefined || sanitizedValues[field] === '' || sanitizedValues[field] === null) {
          sanitizedValues[field] = null;
        } else if (field === 'bond_value' || field === 'bg_value') {
          const parsed = parseFloat(sanitizedValues[field]);
          sanitizedValues[field] = isNaN(parsed) ? null : parsed;
        }
      });

      // Ensure bond_type_id is number or null
      if (sanitizedValues.bond_type_id !== undefined && sanitizedValues.bond_type_id !== null && sanitizedValues.bond_type_id !== '') {
        sanitizedValues.bond_type_id = Number(sanitizedValues.bond_type_id);
      } else {
        sanitizedValues.bond_type_id = null;
      }

      const response = await updateBondDetailsService(formValues.signal_bond_details_id, sanitizedValues, token);
      props.handleClose("update");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setFormValues(props.data || {});
  }, [props.data, props.open]);

  return (
    <Modal
      title={"Edit Bond Details"}
      open={props.open}
      onCancel={handleCancel}
      footer={[
        <Button key="submit" type="primary" className="cip-btn-submit" onClick={handleOk}>
          Update
        </Button>,
      ]}
    >
      <Card>
        <Card.Body>
          <hr className="hr-horizontal" />
          <Form>
            <Form.Group as={Row} className="mb-3" controlId="file_no">
              <Form.Label column sm="4">File No.</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  name="file_no"
                  value={formValues.file_no || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="bond_type">
              <Form.Label column sm="4">Bond Type*</Form.Label>
              <Col sm="8">
                <Form.Control
                  as="select"
                  name="bond_type"
                  value={formValues.bond_type || ''}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">-- Select Bond Type --</option>
                  {props.dropdownData.bondTypes.map((type, index) => (
                    <option key={type.bond_type_id} value={type.bond_type_code}>
                      {type.bond_type_name + " (" + type.bond_type_code + ")"}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="bond_name">
              <Form.Label column sm="4">Bond Name*</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  name="bond_name"
                  value={formValues.bond_name || ''}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="submitted_to">
              <Form.Label column sm="4">Submitted To</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  name="submitted_to"
                  value={formValues.submitted_to || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="bond_no">
              <Form.Label column sm="4">Bond No.*</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  name="bond_no"
                  value={formValues.bond_no || ''}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="bg_no">
              <Form.Label column sm="4">BG No.</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  name="bg_no"
                  value={formValues.bg_no || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="accepted_date">
              <Form.Label column sm="4">Accepted Date</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="date"
                  name="accepted_date"
                  value={formValues.accepted_date || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="expiry_date">
              <Form.Label column sm="4">Expiry Date</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="date"
                  name="expiry_date"
                  value={formValues.expiry_date || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="bond_value">
              <Form.Label column sm="4">Bond Value</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  name="bond_value"
                  value={formValues.bond_value || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="bg_value">
              <Form.Label column sm="4">BG Value</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  name="bg_value"
                  value={formValues.bg_value || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="obligation_base">
              <Form.Label column sm="4">Obligation Base</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="text"
                  name="obligation_base"
                  value={formValues.obligation_base || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="date">
              <Form.Label column sm="4">Bond Date*</Form.Label>
              <Col sm="8">
                <Form.Control
                  type="date"
                  name="date"
                  value={formValues.date || ''}
                  onChange={handleInputChange}
                />
              </Col>
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    </Modal>
  );
};

export default BondEditModal;
